import type { IconData } from '@stacksjs/iconify-core'

export const devicesDatabase: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 8c3.866 0 7-1.79 7-4s-3.134-4-7-4s-7 1.79-7 4s3.134 4 7 4\"/><path fill=\"currentColor\" d=\"M13.694 8.13C12.162 9.007 10.146 9.5 8 9.5s-4.162-.494-5.694-1.37A7 7 0 0 1 1 7.179V8c0 2.21 3.134 4 7 4s7-1.79 7-4v-.822a7 7 0 0 1-1.306.953\"/><path fill=\"currentColor\" d=\"M1 11.178V12c0 2.21 3.134 4 7 4s7-1.79 7-4v-.822a7 7 0 0 1-1.306.953C12.162 13.006 10.146 13.5 8 13.5s-4.162-.494-5.694-1.37A7 7 0 0 1 1 11.179\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesDatabase
